import { Box, Container } from '@mui/system'
import React from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Typography, Button } from '@mui/material';
import { pink } from '@mui/material/colors';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import useAxios from "../../hooks/use-axios"
import { useState } from 'react';
import LoopIcon from '@mui/icons-material/Loop';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import { useTheme } from '@emotion/react'

const RenderMessage = () => {
	const theme = useTheme()
	const axios = useAxios()
	const [paramsString] = useSearchParams();
	const navigate = useNavigate()

	const [response, setResponse] = useState('LOADING');
	const activateAccount = async () => {
		try {
			const resp = await axios.get('accounts/activate/', {
				params: {
					uid: paramsString.get('uid'), token: paramsString.get('token')
				}
			})
			setResponse(resp.data.data.reason)
			setTimeout(() => {
				navigate('/accounts/signin')
			}, 3000)
		}
		catch (error) {
			console.error(error)
			if (!error.response) {
				setResponse('NETWORK_ERROR')
			}
			else {
				setResponse(error.response.data.data.reason)
			}
		}
	}
	useEffect(() => {
		activateAccount()
	}, [])

	switch (response) {
		case 'LINK_VALID':
			return (
				<>

					<Box sx={{ textAlign: "center", mt: 2 }}>
						<CheckCircleIcon sx={{ fontSize: "60px", color: theme.palette.mode === "dark" ? theme.palette.primary.main : theme.palette.primary.main }}></CheckCircleIcon>
					</Box>
					<Box sx={{ mt: 2, textAlign: "center" }}>
						<Typography sx={{ fontWeight: 500, fontSize: "26px" }}>Account Activated Successfull</Typography>
					</Box>
					<Box sx={{ mt: 1, textAlign: "center" }}>
						<Typography sx={{ fontWeight: 400, fontSize: "16px" }}>Please wait while we redirecting you to login page</Typography>
					</Box>
					<Box sx={{ mt: 3, textAlign: "center", mb: 3 }}>
						<Button variant='contained' type="submit" color="info" onClick={() => { navigate('/accounts/signin') }}>log in</Button>
					</Box>
				</>
			)
		case 'LINK_ALREADY_USED':
			return (
				<>
					<Box sx={{ textAlign: "center", mt: 2 }}>
						<ErrorOutlineIcon sx={{ fontSize: "60px", color: pink[500] }}></ErrorOutlineIcon>
					</Box>
					<Box sx={{ mt: 2, textAlign: "center" }}>
						<Typography sx={{ fontWeight: 500, fontSize: "26px" }}>Verification link is already used</Typography>
					</Box>
					<Box sx={{ mt: 3, textAlign: "center", mb: 3 }}>
						<Button variant='contained' type="submit" color="error" onClick={() => { navigate('/accounts/resend') }}>Resend</Button>
					</Box>
				</>
			)
		case 'LINK_EXPIRED':
			return (
				<>
					<Box sx={{ textAlign: "center", mt: 2 }}>
						<ErrorOutlineIcon sx={{ fontSize: "60px", color: pink[500] }}></ErrorOutlineIcon>
					</Box>
					<Box sx={{ mt: 2, textAlign: "center" }}>
						<Typography sx={{ fontWeight: 500, fontSize: "26px" }}>Verification link is expired</Typography>
					</Box>

					<Box sx={{ mt: 3, textAlign: "center", mb: 3 }}>
						<Button variant='contained' type="submit" color="error" onClick={() => { navigate('/accounts/resend') }} >Resend</Button>
					</Box>
				</>
			)
		case 'LINK_INVALID_USER_ACTIVATE':
			return (
				<>
					<Box sx={{ textAlign: "center", mt: 2 }}>
						<ErrorOutlineIcon sx={{ fontSize: "60px", color: pink[500] }}></ErrorOutlineIcon>
					</Box>
					<Box sx={{ mt: 2, textAlign: "center" }}>
						<Typography sx={{ fontWeight: 500, fontSize: "26px" }}>User already activated</Typography>
					</Box>
				</>
			)
		case 'LINK_INVALID':
			return (
				<>
					<Box sx={{ textAlign: "center", mt: 2 }}>
						<ErrorOutlineIcon sx={{ fontSize: "60px", color: pink[500] }}></ErrorOutlineIcon>
					</Box>
					<Box sx={{ mt: 2, textAlign: "center" }}>
						<Typography sx={{ fontWeight: 500, fontSize: "26px" }}>Verification link is invalid</Typography>
					</Box>

					<Box sx={{ mt: 3, textAlign: "center", mb: 3 }}>
						<Button variant='contained' type="submit" color="error" onClick={() => { navigate('/accounts/resend') }}>Resend</Button>
					</Box>
				</>
			)
		case 'LOADING':
			return (
				<>
					<Box sx={{ textAlign: "center", mt: 2 }}>
						<LoopIcon sx={{ fontSize: "60px", color: pink[500] }}></LoopIcon>
					</Box>
					<Box sx={{ mt: 2, textAlign: "center" }}>
						<Typography sx={{ fontWeight: 500, fontSize: "26px" }}>Activating Account</Typography>
					</Box>
					<Box sx={{ mt: 1, textAlign: "center" }}>
						<Typography sx={{ fontWeight: 400, fontSize: "16px" }}>Please wait while we activating your account</Typography>
					</Box>
				</>
			)
		default:
			return (
				<>
					<Box sx={{ textAlign: "center", mt: 2 }}>
						<ErrorOutlineIcon sx={{ fontSize: "60px", color: pink[500] }}></ErrorOutlineIcon>
					</Box>
					<Box sx={{ mt: 2, textAlign: "center" }}>
						<Typography sx={{ fontWeight: 500, fontSize: "26px" }}>Unable to activate account</Typography>
					</Box>
					<Box sx={{ mt: 3, textAlign: "center", mb: 3 }}>
						<Button variant='contained' type="submit" color="error" onClick={activateAccount}>try again</Button>
					</Box>
				</>
			)
	}
}
const Activate = () => {
	return (
		<Box>
			<Navbar />
			<Container maxWidth="sm">
				<Box sx={{ boxShadow: "0 5px 15px rgba(0,0,0,.08)", borderRadius: "6px", padding: "15px", marginTop: "6rem" }}>
					<RenderMessage />
				</Box>
			</Container>
		</Box>
	)
}

export default Activate